export enum StatusOptions {
  OK = 'OK',
  ERROR = 'ERROR',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  RELOGIN = 'RELOGIN',
  NOT_ALLOWED = 'NOT_ALLOWED',
  MAINTENANCE = 'MAINTENANCE',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  MISSING_PATIENT_INFO = 'MISSING_PATIENT_INFO',
  MISSING_PAYMENT_INFO = 'MISSING_PAYMENT_INFO',
  ERROR_CREDENTIALS = 'ERROR_CREDENTIALS',
  INSURANCE_NO_LONGER_VALID = 'INSURANCE_NO_LONGER_VALID',
  NO_LONGER_AVAILABLE = 'NO_LONGER_AVAILABLE',
}

export enum VisitStatus {
  NEW = 'NEW',
  QUEUED = 'QUEUED',
  CANCELLED = 'CANCELLED',
  STARTED = 'STARTED',
  FAILED_PREAUTH = 'FAILED_PREAUTH',
  FULLY_PAID = 'FULLY_PAID',
  REFUNDED = 'REFUNDED',
  DOCTOR_ACCEPTED = 'DOCTOR_ACCEPTED',
  DOCTOR_ASSIGNED = 'DOCTOR_ASSIGNED',
  DOCTOR_REASSIGNED = 'DOCTOR_REASSIGNED',
  DOCTOR_ENROUTE = 'DOCTOR_ENROUTE',
  DOCTOR_ACKNOWLEDGED = 'DOCTOR_ACKNOWLEDGED',
  DOCTOR_NOT_FOUND = 'DOCTOR_NOT_FOUND',
  NOT_AUTHORIZED_VALIDATION = 'NOT_AUTHORIZED_VALIDATION',
  NOTES_UPDATED = 'NOTES_UPDATED',
  SYMPTOMS_UPDATED = 'SYMPTOMS_UPDATED',
  MEDICAL_ASSISTANT_ASSIGNED = 'MEDICAL_ASSISTANT_ASSIGNED',
  MEDICAL_ASSISTANT_REASSIGNED = 'MEDICAL_ASSISTANT_REASSIGNED',
  SCHEDULED_TIME_CHANGED = 'SCHEDULED_TIME_CHANGED',
  SEARCHING_DOCTOR = 'SEARCHING_DOCTOR',
  COMPLETED = 'COMPLETED',
}

export function isFutureVisitStatus(status: VisitStatus) {
  return new Set([
    VisitStatus.NEW,
    VisitStatus.QUEUED,
    VisitStatus.STARTED,
    VisitStatus.DOCTOR_ACCEPTED,
    VisitStatus.DOCTOR_ASSIGNED,
    VisitStatus.DOCTOR_REASSIGNED,
    VisitStatus.DOCTOR_ENROUTE,
    VisitStatus.DOCTOR_ACKNOWLEDGED,
    VisitStatus.DOCTOR_NOT_FOUND,
    VisitStatus.NOT_AUTHORIZED_VALIDATION,
    VisitStatus.NOTES_UPDATED,
    VisitStatus.SYMPTOMS_UPDATED,
    VisitStatus.MEDICAL_ASSISTANT_ASSIGNED,
    VisitStatus.MEDICAL_ASSISTANT_REASSIGNED,
    VisitStatus.SCHEDULED_TIME_CHANGED,
    VisitStatus.SEARCHING_DOCTOR,
  ]).has(status);
}

export function isPastVisitStatus(status: VisitStatus) {
  return new Set([VisitStatus.CANCELLED, VisitStatus.FULLY_PAID, VisitStatus.REFUNDED]).has(status);
}

export function isCompletedVisitStatus(status: VisitStatus) {
  return new Set([VisitStatus.FULLY_PAID, VisitStatus.REFUNDED]).has(status);
}

export enum BillStatus {
  PENDING_CAPTURE = 'PENDING_CAPTURE',
  PENDING_CHARGE = 'PENDING_CHARGE',
  ERROR_CHARGE = 'ERROR_CHARGE',
  CHARGED = 'CHARGED',
  NO_CHARGE = 'NO_CHARGE',
  REFUNDED = 'REFUNDED',
  DEFERRED = 'DEFERRED',
}
